import { render, staticRenderFns } from "./finishFile-add.vue?vue&type=template&id=37b5d8dc&scoped=true&"
import script from "./finishFile-add.vue?vue&type=script&lang=js&"
export * from "./finishFile-add.vue?vue&type=script&lang=js&"
import style0 from "./finishFile-add.vue?vue&type=style&index=0&id=37b5d8dc&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b5d8dc",
  null
  
)

export default component.exports